import React from "react";
import * as ReactBootstrap from "react-bootstrap";
import { dollarUS } from "../../utilities/formatters";

const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const StatFormatter = (data) => {
  const Stat = data.toLowerCase();

  const classList =
    String(Stat).toLowerCase() === "success"
      ? "StatusPassed"
      : String(Stat).toLowerCase() === "failed"
      ? "StatusFailed"
      : "StatusInProgress";

  return <div className={`Status ${classList}`}>{data}</div>;
};

const FinalEvalTable = ({ data, Objectives }) => {
  const ProfitTargetObj = () => {
    if (Objectives && Objectives["profit_target"]) {
      return (
        <tr>
          <td width={"100%"}>{`Profit ${dollarUS(
            Objectives["profit_target"]["target"]
          )}`}</td>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              padding: "0px",
            }}
          >
            <td>{StatFormatter(Objectives["profit_target"]["status"])}</td>
            <td>{`${dollarUS(
              Objectives["profit_target"]["result"].toFixed(2)
            )} `}</td>
          </div>
        </tr>
      );
    }
    return false;
  };

  const renderFinalEval = (item, index) => {
    let name = "";
    let status = "In Progress";
    let target = "";
    let result = "";
    if (item === "minimum_10_training_days" && Objectives) {
      if (data.account_model.status === "Funded") {
        name = "Withdrawal Dates";
        result = " ";
        status =
          Objectives &&
          Objectives["payout_dates"] &&
          `${Objectives.payout_dates[0]} & ${Objectives.payout_dates[1]}`;
      } else {
        name = `Minimum ${
          Objectives && Objectives["trading_days"]
            ? Objectives["trading_days"]["target"]
            : ""
        } trading days`;
        result = Objectives["trading_days"]["result"];
        status = Objectives["trading_days"]["status"];
      }
    } else if (item === "max_loss") {
      target = Number(data.account_model.challenge.Max_Loss);
      name = "Max Loss";
      result =
        Objectives &&
        Objectives["drawdown_result"] &&
        Objectives["drawdown_result"]["max_loss"] &&
        dollarUS(
          Objectives["drawdown_result"]["max_loss"]["result"].toFixed(2)
        );
      status =
        Objectives &&
        Objectives["drawdown_result"] &&
        Objectives["drawdown_result"]["max_loss"]["status"];
      target =
        Objectives &&
        Objectives["drawdown_result"] &&
        dollarUS(Number(Objectives["drawdown_result"]["max_loss"]["target"]));
    } else if (item === "max_daily_loss") {
      name = "Max Daily Loss";
      target =
        Objectives &&
        Objectives["drawdown_result"] &&
        dollarUS(
          Number(
            Objectives["drawdown_result"]["max_daily_loss"]["target"]
          ).toFixed(2)
        );
      result =
        Objectives &&
        Objectives["drawdown_result"] &&
        Objectives["drawdown_result"]["max_daily_loss"] &&
        dollarUS(
          Objectives["drawdown_result"]["max_daily_loss"]["result"].toFixed(2)
        );
      status =
        Objectives &&
        Objectives["drawdown_result"] &&
        Objectives["drawdown_result"]["max_daily_loss"]["status"];
    }
    return (
      <tr key={index}>
        <td>{`${name} ${target} `}</td>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            padding: "0px",
            gap: "20px",
          }}
        >
          <td>{StatFormatter(status)}</td>
          <td>{`${result} `}</td>
        </div>
      </tr>
    );
  };

  return (
    <div className="CommonTable">
      <ReactBootstrap.Table>
        <thead>
          {/* <tr>
            <th>Trading Objectives</th>
            <th>Results</th>
            <th>Summary</th>
          </tr> */}
        </thead>
        <tbody>
          {Objectives && <ProfitTargetObj />}
          {Objectives &&
            Object.keys(data.final_evaluation).length &&
            Object.keys(data.final_evaluation).map(renderFinalEval)}
        </tbody>
      </ReactBootstrap.Table>
    </div>
  );
};

export default FinalEvalTable;
